import { useQuery } from '@tanstack/react-query';
import { fetchMyTimeEntries, type TimeEntriesResponse } from '../lib/api';
import { useOnlineStatus } from './useOnlineStatus';
import { getPendingTimeEntries, type OfflineTimeEntry } from '../lib/db';

export function useTimeEntries() {
  const isOnline = useOnlineStatus();

  return useQuery<{ entries: TimeEntriesResponse['data']; pending: OfflineTimeEntry[] }>({
    queryKey: ['my-time-entries', isOnline],
    queryFn: async () => {
      const pending = await getPendingTimeEntries().catch(() => []);

      if (!isOnline) {
        return { entries: [], pending };
      }

      try {
        const response = await fetchMyTimeEntries({ limit: 50 });
        return { entries: response.data, pending };
      } catch {
        return { entries: [], pending };
      }
    },
    refetchInterval: isOnline ? 60000 : false,
    staleTime: 30000,
  });
}
